import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { logout, ssoValidateToken } from '../../actions/authentication';
import PropTypes from 'prop-types';

function SSOLogin({ validateSSOToken = () => {}, logout = () => {} }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const langCode = queryParams.get('LanguageCode') || null;

    if (token) {
      validateSSOToken(token, langCode);
    } else {
      logout();
      navigate('/login');
    }
  }, []);

  return null;
}

SSOLogin.propTypes = {
  validateSSOToken: PropTypes.func,
  logout: PropTypes.func,
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  validateSSOToken: (token, languageCode) =>
    dispatch(ssoValidateToken(token, languageCode)),
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SSOLogin);
